import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import clsx from "clsx";
import styles from "./Custom.module.scss.js";
const Custom = memo(function Custom2({ className, ...props }) {
  return /* @__PURE__ */ jsx("div", { className: clsx(styles.custom, className), ...props });
});
export {
  Custom
};
